import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SchemaOrg from "@/components/feature/SchemaOrg";
import { siteInfo } from "@/mocks/articles";

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `关于我们 - ${siteInfo.name}`,
          url: `${siteInfo.domain}/about`,
          description: `${siteInfo.name}是国内领先的娱乐八卦资讯平台，致力于为吃瓜群众提供最真实、最及时、最深度的明星网红爆料内容。`,
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "首页",
              item: siteInfo.domain,
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "关于我们",
            },
          ],
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "黑料吃瓜是什么样的平台？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "黑料吃瓜是国内领先的娱乐八卦资讯平台，成立于2024年，致力于为吃瓜群众提供最真实、最及时、最深度的明星网红爆料内容。每一篇报道都经过团队严格核实。",
              },
            },
            {
              "@type": "Question",
              name: "黑料吃瓜的爆料内容是否真实？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "是的，黑料吃瓜承诺每一条爆料都经过交叉验证，绝不传播未经证实的谣言。我们由资深娱乐记者和调查记者组成的编辑团队全天候追踪娱乐圈动态。",
              },
            },
            {
              "@type": "Question",
              name: "如何联系黑料吃瓜进行商务合作？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "您可以通过商务合作邮箱 business@heiliao-chigua.com 与我们联系。无论您是品牌方、艺人团队还是内容创作者，我们都欢迎您的合作洽谈。",
              },
            },
            {
              "@type": "Question",
              name: "如果发现内容侵权怎么办？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "如果您认为黑料吃瓜的内容侵犯了您的合法权益，请发送邮件至 complaint@heiliao-chigua.com，我们会在收到投诉后第一时间核实并处理。",
              },
            },
          ],
        }}
      />
      <Navbar />
      <main className="min-h-screen">
        <div className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-50">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>

        <section className="py-0 bg-background-50">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pb-14 md:pb-18">
              <div className="lg:w-[45%]">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 leading-tight">
                  还原真实
                  <br />
                  <span className="text-accent-500">拒绝虚假</span>
                </h1>
                <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
                  黑料吃瓜成立于2024年，是国内领先的娱乐八卦资讯平台。我们致力于为吃瓜群众提供
                  最真实、最及时、最深度的明星网红爆料内容。每一篇报道都经过团队严格核实，
                  拒绝谣言和虚假信息，坚持做有态度的娱乐新媒体。
                </p>
                <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-lg">
                  我们的编辑团队由资深娱乐记者、调查记者和社交媒体分析师组成，
                  全天候追踪娱乐圈动态，为您带来第一手的塌房现场报道。
                </p>
              </div>

              <div className="lg:w-[55%]">
                <div className="rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20composition%20of%20overlapping%20newspaper%20pages%20and%20camera%20lenses%20floating%20in%20soft%20golden%20light%2C%20editorial%20office%20atmosphere%20with%20warm%20amber%20tones%2C%20sophisticated%20journalism%20aesthetic%2C%20clean%20minimalist%20background%2C%204K%20editorial%20photography%2C%20no%20text%20no%20faces&width=900&height=600&seq=about-hero&orientation=landscape"
                    alt="黑料吃瓜品牌"
                    className="w-full h-auto object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-[1000px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950">
              我们的<span className="text-accent-500">影响力</span>
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
              用数据说话，黑料吃瓜已成为中文互联网最具影响力的娱乐八卦平台之一
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8 mt-10">
              <div className="bg-background-50 rounded-lg p-6">
                <p className="text-3xl md:text-4xl font-black text-primary-500">12,800+</p>
                <p className="text-sm text-foreground-600 mt-1.5">累计独家爆料</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6">
                <p className="text-3xl md:text-4xl font-black text-accent-500">15亿+</p>
                <p className="text-sm text-foreground-600 mt-1.5">总阅读量</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6">
                <p className="text-3xl md:text-4xl font-black text-secondary-500">3,200+</p>
                <p className="text-sm text-foreground-600 mt-1.5">覆盖明星网红</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6">
                <p className="text-3xl md:text-4xl font-black text-primary-500">500万+</p>
                <p className="text-sm text-foreground-600 mt-1.5">日均活跃用户</p>
              </div>
            </div>

            <div className="mt-10">
              <a
                href="mailto:business@heiliao-chigua.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all"
              >
                商务合作
                <i className="ri-mail-line"></i>
              </a>
            </div>

            <div className="mt-8 flex items-center justify-center gap-8 opacity-25">
              <span className="text-xs font-semibold text-foreground-600">合作媒体</span>
              <span className="text-sm font-bold text-foreground-600">娱乐周刊</span>
              <span className="text-sm font-bold text-foreground-600">八卦日报</span>
              <span className="text-sm font-bold text-foreground-600">星闻快报</span>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-50">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
              <div className="lg:w-[60%]">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-foreground-950"></span>
                  <span className="text-[11px] font-medium text-foreground-500">我们的态度</span>
                </div>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-foreground-950 leading-tight">
                  <span className="text-foreground-400">&ldquo;</span>
                  不制造谣言，
                  <br />
                  只还原真相
                  <span className="text-foreground-400">&rdquo;</span>
                </h2>
                <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-lg">
                  在这个信息爆炸的时代，真真假假的娱乐八卦充斥网络。黑料吃瓜的创立初衷，
                  就是为吃瓜群众提供一个可信赖的信息来源。我们承诺：每一条爆料都经过交叉验证，
                  每一个标题都真实反映内容，绝不做标题党，绝不传播未经证实的谣言。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-lg">
                  我们尊重每一位艺人，也理解每一位吃瓜群众的好奇心。在报道事实的同时，
                  我们始终坚守新闻伦理底线，不以伤害他人为目的。还原真相是我们的使命，
                  保持克制是我们的态度。
                </p>
                <div className="flex items-center gap-3 mt-6 pt-4 border-t border-background-200/70">
                  <div className="w-10 h-10 rounded-full bg-secondary-500 flex items-center justify-center">
                    <i className="ri-user-line text-background-50 text-base"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">黑料吃瓜编辑部</p>
                    <div className="flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-green-500"></span>
                      <span className="text-[11px] text-foreground-500">官方认证</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-[40%]">
                <div className="rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20editorial%20composition%20of%20a%20vintage%20typewriter%20and%20scattered%20press%20passes%20on%20a%20wooden%20desk%2C%20window%20light%20creating%20dramatic%20shadows%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%20monochrome%2C%20cinematic%20composition%2C%204K%20editorial%20photography%2C%20no%20faces%20no%20text&width=800&height=1100&seq=about-team&orientation=portrait"
                    alt="编辑团队"
                    className="w-full h-auto object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
              <div className="lg:w-[40%]">
                <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-foreground-950 leading-tight">
                  合作<span className="text-accent-500">联系</span>
                </h2>
                <p className="text-sm md:text-base font-normal text-foreground-500 mt-1">
                  期待与您携手
                </p>
                <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-sm">
                  无论您是品牌方、艺人团队还是内容创作者，欢迎与我们取得联系。
                  我们将竭诚为您提供最优质的合作方案。
                </p>

                <div className="mt-6 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">商务合作邮箱</p>
                      <a href="mailto:business@heiliao-chigua.com" className="text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors">
                        business@heiliao-chigua.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
                      <i className="ri-error-warning-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">侵权投诉</p>
                      <a href="mailto:complaint@heiliao-chigua.com" className="text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors">
                        complaint@heiliao-chigua.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-[60%]">
                <div className="flex gap-4">
                  <div className="w-[45%]">
                    <div className="rounded-lg overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20editorial%20office%20with%20multiple%20monitor%20screens%20displaying%20news%20feeds%2C%20warm%20ambient%20lighting%2C%20clean%20wooden%20desk%2C%20professional%20creative%20workspace%2C%20soft%20natural%20light%20from%20windows%2C%204K%20editorial%20photography%2C%20no%20people%20no%20text&width=600&height=750&seq=about-office-1&orientation=portrait"
                        alt="办公环境"
                        className="w-full h-auto object-cover rounded-lg"
                      />
                    </div>
                  </div>
                  <div className="w-[55%]">
                    <div className="rounded-lg overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Editorial%20team%20brainstorming%20wall%20with%20red%20string%20connections%20between%20photos%20and%20newspaper%20clippings%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20overhead%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20tones%20with%20deep%20shadows%2C%204K%20editorial%20photography%2C%20no%20faces%20visible&width=750&height=1000&seq=about-office-2&orientation=portrait"
                        alt="调查墙"
                        className="w-full h-auto object-cover rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}